import { render, staticRenderFns } from "./ViewContent.vue?vue&type=template&id=81a82c56"
import script from "./ViewContent.vue?vue&type=script&lang=js"
export * from "./ViewContent.vue?vue&type=script&lang=js"
import style0 from "./ViewContent.vue?vue&type=style&index=0&id=81a82c56&prod&lang=css"
import style1 from "./ViewContent.vue?vue&type=style&index=1&id=81a82c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports